import { render, staticRenderFns } from "./MinhaRespostaProdutosTable.vue?vue&type=template&id=ab14f1ca&scoped=true&"
import script from "./MinhaRespostaProdutosTable.vue?vue&type=script&lang=js&"
export * from "./MinhaRespostaProdutosTable.vue?vue&type=script&lang=js&"
import style0 from "./MinhaRespostaProdutosTable.vue?vue&type=style&index=0&id=ab14f1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab14f1ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDataTable,VRow})
